// The Farmacy theme — mobile menu and catalogue filters.
(function () {
  const menuButton = document.querySelector('.menu-button');
  const menu = document.getElementById('mobile-menu');
  if (menuButton && menu) {
    const openIcon = menuButton.dataset.openIcon || '☰';
    const closeIcon = menuButton.dataset.closeIcon || '×';
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
      menuButton.textContent = expanded ? openIcon : closeIcon;
      menuButton.setAttribute('aria-label', expanded ? menuButton.dataset.labelOpen : menuButton.dataset.labelClose);
    });
  }

  document.querySelectorAll('[data-catalogue]').forEach((catalogue) => {
    const filters = [...catalogue.querySelectorAll('[data-filter]')];
    const items = [...catalogue.querySelectorAll('.filter-item')];
    const empty = catalogue.querySelector('.empty-state');
    filters.forEach((button) =>
      button.addEventListener('click', () => {
        filters.forEach((b) => {
          b.classList.toggle('active', b === button);
          b.setAttribute('aria-pressed', String(b === button));
        });
        let count = 0;
        items.forEach((item) => {
          item.hidden = button.dataset.filter !== 'all' && item.dataset.category !== button.dataset.filter;
          if (!item.hidden) count++;
        });
        if (empty) empty.hidden = count > 0;
      })
    );
  });
})();
